// store.ts
import { combineReducers, configureStore } from "@reduxjs/toolkit";

import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

import ContainerData from "./Auth";
import cartReducer from "./Cart/cartSlice"; // Import cartReducer
import meReducer from "./Me/meSlice"; // Import cartReducer
import wishlistReducer from "./Wishlist/wishlistSlice"; // Import wishlistReducer

export type RootState = ReturnType<typeof store.getState>;

const persistConfig = {
  key: "root",
  storage,
};

const rootReducer = combineReducers({
  ContainerData: ContainerData,
  cart: cartReducer, // Include cartReducer in combineReducers
  Auth: cartReducer, // Include cartReducer in combineReducers
  me: meReducer, // Include cartReducer in combineReducers
  wishlist: wishlistReducer, // Include wishlistReducer in combineReducers
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE', 'persist/REGISTER'],
      },
    }),
});

export default store;
